module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Folder",
      "required": "",
      "error": _vm.errors['folder']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz folder"
    },
    model: {
      value: (_vm.form.folder),
      callback: function($$v) {
        _vm.$set(_vm.form, "folder", $$v)
      },
      expression: "form.folder"
    }
  }, _vm._l((_vm.folders), function(folder) {
    return _c('el-option', {
      key: folder.id,
      attrs: {
        "label": folder.working_name,
        "value": folder.id
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-776d1e0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/InstagramWidget.vue
// module id = 778
// module chunks = 0